define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var DnsZoneModel = /** @class */ (function () {
        function DnsZoneModel(data) {
            this.Id = ko.observable();
            this.DomainName = ko.observable();
            this.Type = ko.observable();
            this.Comment = ko.observable('');
            this.Provider = ko.observable('');
            this.RecordSetCount = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, DnsZoneModel.Mapping, self);
            }
        }
        DnsZoneModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new DnsZoneModel(options.data);
            }
        };
        return DnsZoneModel;
    }());
    return DnsZoneModel;
});
//# sourceMappingURL=DnsZoneModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/DnsZoneModel.js
// module id = 242
// module chunks = 2